import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shuffle } from '@/components/Icons/Shuffle';

interface Props {
  changedLessonCount: number;
}

export const DiaryChangesCard: React.FC<Props> = ({ changedLessonCount }) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4 flex w-full items-center gap-3 rounded-xl bg-orange-soft p-3 text-body-13 text-foreground contrast:border contrast:border-border md:mb-3 md:w-fit">
      <Shuffle className="size-4 shrink-0 text-accent" />
      {t('diary.changesCount', { count: changedLessonCount })}
    </div>
  );
};
